import { z } from "zod"

export const BLANK_PRODUCT_MANAGER_VALUE = {
  id: "",
  name: "",
}

const fieldMaxLength = 30

export const ProductInfoFormSchema = z.object({
  companyId: z.string().optional(),
  vendorSku: z
    .string()
    .max(fieldMaxLength, { message: `Vendor SKU must be less than ${fieldMaxLength} characters` })
    .optional(),
  vendorDescription: z
    .string()
    .min(1, { message: "Vendor Description is required" })
    .max(fieldMaxLength, { message: `Vendor Description must be less than ${fieldMaxLength} characters` }),
  companyProductDescription: z
    .string()
    .min(1, { message: "Akrochem Description is required" })
    .max(fieldMaxLength, { message: `Akrochem Description must be less than ${fieldMaxLength} characters` }),
  locationsAssociations: z
    .array(
      z.object({
        address1: z.string().optional(),
        city: z.string().optional(),
        regionIsoCode: z.string().optional(),
        locationAssociationId: z.string().optional(),
      })
    )
    .optional()
    .default([]),
})

export const ProductSpecificsFormSchema = z.object({
  classification: z.string().min(1, { message: "Product Class is required" }),
  category: z.string().min(1, { message: "Product Category is required" }),
  productFormInfo: z.string().min(1, { message: "Product Form is required" }),
  productManager: z.object({
    id: z.string(),
    name: z.string(),
  }),
  uomId: z.string().min(1, { message: "Unit of Measurement is required" }),
})

export const ProductAddFormSchema = ProductInfoFormSchema.merge(ProductSpecificsFormSchema)

export const ProductSkuAddFormSchema = ProductInfoFormSchema.pick({ vendorSku: true })

export const ProductLocationAddFormSchema = ProductInfoFormSchema.pick({ companyId: true, locationsAssociations: true })

export type ProductInfoFormValues = z.infer<typeof ProductInfoFormSchema>

export type ProductSpecificsFormValues = z.infer<typeof ProductSpecificsFormSchema>

export type ProductAddFormValues = z.infer<typeof ProductAddFormSchema>

export type ProductSkuAddFormValues = z.infer<typeof ProductSkuAddFormSchema>

export type ProductLocationAddFormValues = z.infer<typeof ProductLocationAddFormSchema>
